import React, { useMemo } from "react";
import { FiltersTypes } from "@common/types/filters/general";
import {
    COUNTERPARTY_GLOBAL_SOURCE_LABEL,
    COUNTERPARTY_SOURCE_LABELS,
} from "@common/helpers/counterparties";
import { useCurrentWorkspaceMembers } from "@api/workspaceMember.api";
import { formatFilterLabel } from "./formatFilterLabel";

interface Props {
    filters: FiltersTypes;
}

export const CounterpartyCreatedByFilterLabel: React.FC<Props> = ({
    filters,
}) => {
    const { data: workspaceMembers } = useCurrentWorkspaceMembers();
    const { createdByKick, createdByUserIds, createdBySources } = filters;

    const labels = useMemo(() => {
        const result: string[] = [];
        if (createdByKick) {
            result.push(COUNTERPARTY_GLOBAL_SOURCE_LABEL);
        }
        for (const member of workspaceMembers ?? []) {
            if (createdByUserIds?.includes(member.user.id)) {
                result.push(member.user.preferredName ?? member.user.name);
            }
        }
        for (const source of createdBySources ?? []) {
            result.push(COUNTERPARTY_SOURCE_LABELS[source]);
        }
        return result;
    }, [workspaceMembers, createdByKick, createdByUserIds, createdBySources]);

    if (
        !createdByKick &&
        (!createdByUserIds || createdByUserIds.length === 0) &&
        (!createdBySources || createdBySources.length === 0)
    ) {
        return null;
    }

    // Defer rendering until members resolve, otherwise selected user IDs map to
    // an empty label array and the chip renders blank while data is loading.
    if (createdByUserIds && createdByUserIds.length > 0 && !workspaceMembers) {
        return null;
    }

    return formatFilterLabel(labels);
};
